import { render, staticRenderFns } from "./OnlinePaymentDialog.vue?vue&type=template&id=2c23923f&scoped=true"
import script from "./OnlinePaymentDialog.vue?vue&type=script&lang=js"
export * from "./OnlinePaymentDialog.vue?vue&type=script&lang=js"
import style0 from "./OnlinePaymentDialog.vue?vue&type=style&index=0&id=2c23923f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c23923f",
  null
  
)

export default component.exports